import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Nature of the product",
    paragraphs: [
      "The BuildOnce Clarity Kit is a self-guided decision-support tool designed to help founders and independent consultants think through business challenges, clarify priorities, and structure their thinking. It is not a professional advisory, consulting, coaching, or financial service.",
      "**This is not professional advice.** Nothing contained in the Clarity Kit, including the exercises, frameworks, written content, or AI-generated responses, constitutes financial, legal, accounting, tax, marketing, psychological, or professional advisory advice of any kind. Do not make significant business, financial, or legal decisions based solely on the content of the Clarity Kit without independent professional advice.",
    ],
  },
  {
    heading: "AI-generated content disclaimer",
    paragraphs: [
      "The Clarity Kit includes an AI thinking partner powered by Anthropic's Claude. The following limitations apply to all AI-generated content:",
    ],
    bullets: [
      "AI responses are generated automatically based on the inputs you provide. They are reflective and informational in nature.",
      "AI responses may be inaccurate, incomplete, outdated, or unsuitable for your specific circumstances.",
      "The AI thinking partner does not have access to your full business context, financials, legal situation, or market data.",
      "BuildOnce Studio does not verify, review, or take responsibility for individual AI-generated responses.",
      "Responses generated by AI are not a substitute for qualified professional advice.",
    ],
    note: "You are solely responsible for evaluating the relevance and accuracy of any AI-generated content and for any decisions you make in reliance on it. Always apply your own professional judgment.",
  },
  {
    heading: "No guarantee of results",
    paragraphs: [
      "The effectiveness of the Clarity Kit depends entirely on the quality, honesty, and completeness of the information you provide, and your subsequent application of the outputs. BuildOnce Studio makes no guarantee, representation, or warranty that:",
    ],
    bullets: [
      "You will achieve any specific business outcome as a result of using the Clarity Kit.",
      "The frameworks, exercises, or AI responses will be suitable for your specific industry, market, or business model.",
      "The insights generated will be accurate, current, or applicable to your situation.",
    ],
    note: "Individual results will vary based on your circumstances, effort, and how you apply the tool.",
  },
  {
    heading: "External links and third-party content",
    paragraphs: [
      "The Clarity Kit may reference or link to external websites, tools, or resources. BuildOnce Studio is not responsible for the content, accuracy, or availability of external resources and does not endorse any third-party products or services mentioned in the kit.",
    ],
  },
  {
    heading: "Intellectual property",
    paragraphs: [
      "The Clarity Kit, including all exercises, frameworks, prompts, and AI system configurations, is the intellectual property of BuildOnce Studio and Jophy Orenza. Reproduction, redistribution, or commercial use of any part of the kit without written permission is strictly prohibited.",
    ],
  },
  {
    heading: "Limitation of liability",
    paragraphs: [
      "To the fullest extent permitted by Singapore law, BuildOnce Studio, its founder, and affiliates shall not be liable for any direct, indirect, incidental, consequential, or special damages arising from your use of or reliance on the Clarity Kit or any content contained therein, including AI-generated responses.",
    ],
  },
  {
    heading: "Governing law",
    paragraphs: [
      "This Disclaimer is governed by the laws of Singapore. By using the Clarity Kit, you agree that any disputes will be subject to the exclusive jurisdiction of the Singapore courts.",
    ],
  },
  {
    heading: "Contact",
    paragraphs: [
      "BuildOnce Studio · info@buildoncestudio.com · buildoncestudio.com · UEN: 53518159X · Singapore",
    ],
  },
];

export default function Disclaimer() {
  return (
    <LegalLayout
      testId="disclaimer-page"
      eyebrow="Legal · Disclaimer"
      title="Disclaimer."
      intro="Important notice regarding the nature and limitations of the BuildOnce Clarity Kit."
      sections={sections}
    />
  );
}
